import { render } from "./ExpertToolCall.vue?vue&type=template&id=4df37750&scoped=true"
import script from "./ExpertToolCall.vue?vue&type=script&lang=js"
export * from "./ExpertToolCall.vue?vue&type=script&lang=js"

import "./ExpertToolCall.vue?vue&type=style&index=0&id=4df37750&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df37750"]])

export default __exports__